import Handledataa from "./handledataa";
import Qs from "qs";
import axios from "axios";
import { error, proxy } from "jquery";
import config from "./config";
import router from "@/router/index";
import { authWhiteList } from "./const";
import _ from "lodash";
import { docCookies } from "@/common/js/CookieUtil";
let handledataa = new Handledataa();
let time = ""; // 计时器
import domMessage from "./messageOnce";
import { encryptData, decryptData, restoreAesKey } from "@/utils/crypto.js";
// import axios2 from "axios";
// import { refreshToken } from "@/views/commonApi";
// new 对象实例
const messageOnce = new domMessage();
let refresh = false; // 是否刷新保证 多接口只刷新一次
let errorList = []; // 刷新token后 需要重新请求的接口
class Request {
  constructor() {
    this.api = axios.create(new config());
    this.setRequestInterceptors();
    this.setResponseInterceptors();
    this.setproxy();
  }
  transformGetParams(url) {
    let str = "";
    // 检查是否存在问号
    if (url.includes("?")) {
      // 存在问号，截取问号后面的部分
      const queryUrl = url.split("?")[0];
      const queryString = url.split("?")[1];
      str = queryUrl + "?data=" +encryptData(queryString);
    } else {
      str = url;
    }
    return str;
  }
  setAuthorization(key, item) {
    localStorage.setItem(key, item);
    Authorization: "Bearer " + docCookies.getItem("token");

  }
  // 请求拦截
  setRequestInterceptors() {
    this.api.interceptors.request.use(
      (config) => {
        // 是否需要加密
        if (process.env.VUE_APP_ENCRYPTION === "true") {

          if (!config.isEncrypted) {
            config.headers["X-Encrypt"] = true;
            if (
              config.method.toLowerCase() === "get" ||
              config.method.toLowerCase() === "delete"
            ) {
              config.url = this.transformGetParams(config.url);
            } else {
              const aesKey = restoreAesKey();
              if (aesKey && config.data) {
                // 对请求数据进行加密
                config.data = encryptData(config.data);
                // 如果是 POST 请求，可能需要修改 Content-Type
                if (config.method.toLowerCase() === "post") {
                  config.headers["Content-Type"] = "application/json";
                }
              }
            }
          }

        }
        if (!config.url.includes("/iplatform-bi/")) {
          let token = localStorage.getItem("token");
          const Authorization = "Bearer " + token;
          if (token) {
            if (!_.includes(authWhiteList, config.url)) {
              if (!config.isNotToken) {
                config.headers.Authorization = Authorization;
              } else {
                config.headers.Authorization = "";
              }
            }
            if (!config.fobbidenGateway) {
              config.baseURL = config.baseURL;
            }
          }
        }
        return config;
      },
      (err) => {
        // console.log(err);
        return Promise.reject(err);
      }
    );
  }
  //请求响应
  setResponseInterceptors() {
    this.api.interceptors.response.use(
      (res) => {
        // 是否需要解密
        if (process.env.VUE_APP_ENCRYPTION === "true") {
          // 对响应数据进行解密
          if (typeof res.data === "string") {
            try {
              // 尝试解密
              res.data = decryptData(res.data);
            } catch (error) {
              console.error("数据解密失败:", error);
            }
          }
        }
        return new Promise((resolve, reject) => {
          if (
            res.data instanceof Blob &&
            res.data.type === "application/json"
          ) {
            //这里对文件下载异常单独捕获
            let reader = new FileReader();
            reader.readAsText(res.data, "utf-8");
            reader.onload = function (e) {
              const json = e.target.result;
              const result = JSON.parse(json);
              if (result.code !== 200) {
                messageOnce.error(result.msg);
              }
            };
          }
          if (
            typeof res.data === "object" &&
            Object.prototype.toString.call(res.data) === "[object Object]" &&
            !Array.isArray(res.data)
          ) {
            if (res.data.code !== 200) {
              if (res.data.code === 401) {
                if (time) {
                  clearTimeout(time);
                }
                time = setTimeout(() => {
                  localStorage.clear();
                  router.push("/login");
                }, 300);
              } else if (res.data.code === 402) {
                messageOnce.error(res.data.msg || res.data.message);
                if (time) {
                  clearTimeout(time);
                }

                time = setTimeout(() => {
                  localStorage.clear();
                  router.push("/login");
                }, 300);
              } else if (res.data.code === 111) {
                // messageOnce.error(res.data.msg || res.data.message);
                // 就是将当前的resolve给保存下来，而不是去执行它，只要理解这点你就成功的学会写js了。我这里是给他保存在函数里，到要用的时候用它
                // errorList.push((func) => {
                //   if (func && typeof func === "function") {
                //     func(res, resolve);
                //   } else {
                //     reject("错误");
                //   }
                // });
                // if (!refresh) {
                //   // 这里时只发送一次刷新权限的接口
                //   handleError(this.api);
                //   // 记住，这里要like给他整成true，不然后边的请求就进来了
                //   refresh = true;
                // }
                // return;
                if (time) {
                  clearTimeout(time);
                }
                time = setTimeout(() => {
                  localStorage.clear();
                  router.push("/login");
                }, 300);
              } else if (res.data.code === 110) {
                messageOnce.error(res.data.msg || res.data.message);
                if (time) {
                  clearTimeout(time);
                }

                time = setTimeout(() => {
                  localStorage.clear();
                  router.push("/login");
                }, 300);
              } else {
                messageOnce.error(res.data.msg || res.data.message);
              }
            }
            // // console.log("res.data", res.data);
            resolve(res.data);
          } else {
            resolve(res);
          }
        });
      },
      (error) => {
        //  返回格式待商量
        const code =
          Number(
            error &&
            error.response &&
            error.response.data &&
            error.response.data.code
          ) || 5000;
        // const code = Number(error.response.status) || 5000
        const message =
          (error &&
            error.response &&
            error.response &&
            error.response.data &&
            error.response.data.msg) ||
          "请求错误，请联系管理员";
        // 返回码待商量
        switch (code) {
          case 400: {
            break;
          }
          case 401: {
            if (time) {
              clearTimeout(time);
            }
            time = setTimeout(() => {
              localStorage.clear();
              router.push("/login");
            }, 300);
            break;
          }
          case 404: {
            messageOnce.error("您访问的资源不存在！");
            break;
          }
          case 405: {
            /* Message({
						  type: 'error',
						  message: '请求方法错误'
						}) */
            break;
          }
          case 500: {
            break;
          }
          case 502: {
            if (
              error.response.request.responseURL.indexOf("/dc-api/msg/unread") >
              -1
            ) {
              break;
            }
          }
          default: {
            if (time) {
              clearTimeout(time);
            }
            time = setTimeout(() => {
              messageOnce.error("服务器报错，请联系管理员！");
            }, 300);

            break;
          }
        }
        // console.log(error);
        return Promise.reject(error);
      }
    );
  }

  // 设置实列
  setproxy() {
    this._api = new proxy(this.api, {
      set() {
        throw new error("禁止修改api");
      },
      get(target, property) {
        return target[property];
      },
    });
  }
  //
  async request(params) {
    let url = params.url;
    let reqparams = [];
    // if (
    //   params.method === "delete" &&
    //   !(params && params.config && params.config.headers)
    // )
    //   url += `${handledataa.getPathParams((params && params.data) || {})}`;
    if (
      (params.method === "get" &&
        !(params && params.config && params.config.headers)) ||
      (params.method === "delete" &&
        !(params && params.config && params.config.headers))
    )
      url += `${handledataa.getQueryParams((params && params.data) || {})}`;
    if (params?.path === "path")
      url += `${handledataa.getPathParams((params && params.data) || {})}`;
    reqparams.push(url);
    //   if(params?.isformdata) url.url += `${handledataa.getQueryParams(requestParams.query)}`
    // reqparams = [url]
    // // console.log(params.method === 'post' || params.method === 'put');
    if (
      (params.method === "post" &&
        !(params && params.config && params.config.headers)) ||
      (params.method === "put" &&
        !(params && params.config && params.config.headers))
    ) {
      if (params.data) {
        reqparams.push(Qs.stringify(params.data));
      } else {
        reqparams.push(null);
      }
    } else if (params.method === "post" || params.method === "put") {
      if (params.data) {
        reqparams.push(params.data);
      } else {
        reqparams.push(null);
      }
    }
    if (!!params.config) {
      reqparams.push(params.config);
    }

    // const [res, err] = await this.api[params.method](...reqparams)
    // if (err) return Promise.reject (err);
    // return Promise.resolve (res.data);
    const res = await this.api[params.method](...reqparams);
    // // console.log({reqparams})
    // // console.log({ res });
    // // console.log(reqparams);
    return Promise.resolve(res);
  }
  async send(params) {
    return this.request(params);
  }
}
// function handleError(api) {
//   let refresh_token = localStorage.getItem("refreshToken");
//   axios2
//     .post("/system/sys/refresh_token", { refreshToken: refresh_token })
//     .then((res) => {
//       // 这里刷新了就要恢复成原样，以免在这个权限刷新的时候后续的请求也出现没有权限导致无法再次发起刷新请求
//       refresh = false;
//       if (res.data.code === 200) {
//         // console.log("data", res.data);
//         localStorage.setItem("token", res.data.data.accessToken);
//         localStorage.setItem("refreshToken", res.data.data.refreshToken);
//         errorList.forEach((fun) => {
//           fun((response, resolve) => {
//             resolve(api(response.config));
//           });
//         });
//         // 清空数组，免得越堆越多内存消耗
//         errorList = [];
//       } else {
//         if (time) {
//           clearTimeout(time);
//         }
//
//         time = setTimeout(() => {
//           localStorage.clear();
//           router.push("/login");
//         }, 300);
//       }
//     })
//     .catch(() => {
//       if (time) {
//         clearTimeout(time);
//       }
//
//       time = setTimeout(() => {
//         localStorage.clear();
//         router.push("/login");
//       }, 300);
//     });
// }
function handleError() {
  const request = new Request();
  let refresh_token = localStorage.getItem("refreshToken");
  request
    .send({
      url: `/system/sys/refresh_token`,
      method: "post",
      data: { refreshToken: refresh_token },
      config: {
        isNotToken: true,
        headers: {
          Authorization: "",
          "Content-Type": "application/json",
        },
      },
    })
    .then((res) => {
      // 这里刷新了就要恢复成原样，以免在这个权限刷新的时候后续的请求也出现没有权限导致无法再次发起刷新请求
      refresh = false;
      if (res.code === 200) {
        // console.log("data", res.data);
        localStorage.setItem("token", res.data.accessToken);
        localStorage.setItem("refreshToken", res.data.refreshToken);
        const request2 = new Request();
        errorList.forEach((fun) => {
          fun((response, resolve) => {
            resolve(request.api(response.config));
          });
        });
        // 清空数组，免得越堆越多内存消耗
        errorList = [];
      }
    });
}
export default Request;
